import { useCurrentUser } from "@/hooks/use-current-user";
import { User as UserIcon, ShieldCheck } from "lucide-react";

interface Props {
  variant?: "sidebar" | "menu";
}

export function UserIdentity({ variant = "sidebar" }: Props) {
  const { user, profile, isAdmin, loading } = useCurrentUser();

  if (loading || !user) return null;

  const displayName =
    profile?.full_name ||
    user.user_metadata?.full_name ||
    user.email?.split("@")[0] ||
    "Usuário";
  const email = profile?.email || user.email || "";

  const containerClass =
    variant === "sidebar"
      ? "mx-3 mt-2 mb-3 p-3 rounded-lg bg-[#004080]/60 text-white"
      : "mx-2 mt-2 mb-3 p-3 rounded-lg bg-white/10 text-white";

  return (
    <div className={containerClass}>
      <div className="flex items-center gap-2">
        <div className="w-9 h-9 rounded-full bg-white/20 flex items-center justify-center shrink-0">
          {profile?.avatar_url ? (
            <img
              src={profile.avatar_url}
              alt={displayName}
              className="w-full h-full rounded-full object-cover"
            />
          ) : (
            <UserIcon className="h-5 w-5" />
          )}
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-['Roboto'] font-medium truncate">{displayName}</p>
          <p className="text-xs text-white/70 truncate">{email}</p>
        </div>
      </div>
      {isAdmin && (
        <div className="mt-2 inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-[#E60026] text-white text-[10px] font-semibold uppercase tracking-wide">
          <ShieldCheck className="h-3 w-3" />
          Admin
        </div>
      )}
    </div>
  );
}
